import PreOrderForm from "../components/Preorderform";
import Exibition from "../components/exhibition";
import FooterComponent from "../components/footer";
import HeaderComponent from "../components/header";
import HeroSection from "../components/herosection";

const LandingPage = () => {

    return (

        <div className="landing_page" >
            <HeaderComponent/>
            <HeroSection/>
            <Exibition/>
            <PreOrderForm/>
            <FooterComponent/>
        </div>

    );

}


export default LandingPage